import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../../components/buttons/Button";
import Text from "../../../components/typography/Text";

import { useUserPops } from "../users/hooks/useUserPops";
import FeedPopsView from "../feed/views/FeedPopsView";

import "./FeedPopsPage.css";

const FEED_LIMIT = 10;

export default function FeedPopsPage() {
  const navigate = useNavigate();

  const {
    loading,
    loadingMore,
    error,
    pops,
    hasMore,
    activePopId,
    setActivePopId,
    loadMore,
    refreshFeed,
    recordPopView,
    sharePop,
    savePop,
  } = useUserPops({
    mode: "feed",
    limit: FEED_LIMIT,
  });

  const popItems = Array.isArray(pops) ? pops : [];

  const errorMessage = error
    ? typeof error === "string"
      ? error
      : error?.message || "Unable to load Pops."
    : "";

  const handleCreatorClick = (pop) => {
    const username = pop?.username || pop?.creatorUsername || pop?.creatorTag;

    if (!username) return;

    navigate(`/${encodeURIComponent(username)}`);
  };

  const handlePopView = async (pop, viewDetails = {}) => {
    if (!pop?.popId) return false;

    return recordPopView(pop.popId, viewDetails);
  };

  const handleShare = async (pop) => {
    if (!pop?.popId) return;

    return sharePop(pop);
  };

  const handleSave = async (pop) => {
    if (!pop?.popId) return;

    return savePop(pop);
  };

  return (
    <div className="user-pops-feed-page">
      {errorMessage && (
        <div className="user-pops-feed-page__error" role="alert">
          <Text as="p" size="sm">
            {errorMessage}
          </Text>

          <Button
            value="Try Again"
            variant="primary-outlined"
            onClick={refreshFeed}
            disabled={loading}
          />
        </div>
      )}

      <FeedPopsView
        pops={popItems}
        loading={loading}
        loadingMore={loadingMore}
        hasMore={hasMore}
        activePopId={activePopId}
        setActivePopId={setActivePopId}
        loadMore={loadMore}
        onCreatorClick={handleCreatorClick}
        onView={handlePopView}
        onShare={handleShare}
        onSave={handleSave}
      />
    </div>
  );
}
